import { useState } from 'react'
import { SERVER_LANGUAGE_MAP } from '@/shared/constants/language'
import type { Language } from '@/shared/lib/i18n/use-language'
import type { User } from '@/shared/types/global.types'

/**
 * Language the customer wants our agents to talk to them in, asked during
 * onboarding. It doesn't change the app language. Until the user picks one,
 * it is the server value, or else the app language.
 */
export function useTalkedLanguage(
  user: User | undefined,
  currentLanguage: Language,
) {
  const [pickedLanguage, setTalkedLanguage] = useState<Language>()
  const serverLanguage = user?.talkedLanguage
    ? SERVER_LANGUAGE_MAP[user.talkedLanguage]
    : undefined
  const talkedLanguage = pickedLanguage ?? serverLanguage ?? currentLanguage

  return { talkedLanguage, setTalkedLanguage }
}
